import Link from "next/link";
import {
  Home,
  ShoppingBag,
  Palette,
  User,
  ShoppingCart,
  MapPin,
  Search,
  Bell,
} from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Toaster } from "sonner";

const navItems = [
  { href: "/", icon: Home, label: "首页" },
  { href: "/menu", icon: ShoppingBag, label: "外卖点单" },
  { href: "/cart", icon: ShoppingCart, label: "购物车" },
  { href: "/profile", icon: User, label: "我的" },
];

export function BottomNav() {
  return (
    <>
      <nav className="fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-pink-100 safe-area-bottom">
        <div className="max-w-lg mx-auto flex items-center justify-around h-14">
          {navItems.map((item) => {
            const Icon = item.icon;
            return (
              <Link
                key={item.href}
                href={item.href}
                className="flex flex-col items-center justify-center gap-0.5 w-16 h-full text-muted-foreground hover:text-pink-500 transition-colors"
              >
                <Icon className="w-5 h-5" />
                <span className="text-[10px] font-medium">{item.label}</span>
              </Link>
            );
          })}
        </div>
      </nav>
    </>
  );
}

export function TopBar() {
  return (
    <header className="sticky top-0 z-40 bg-white/80 backdrop-blur-md border-b border-pink-100">
      <div className="max-w-lg mx-auto flex items-center justify-between h-12 px-4">
        <div className="flex items-center gap-2">
          <MapPin className="w-4 h-4 text-pink-500" />
          <span className="text-sm font-medium text-gray-700">
            湘潭市岳塘区
          </span>
          <span className="text-xs text-gray-400">建设路口附近</span>
        </div>
        <div className="flex items-center gap-3">
          <Link href="/search" className="p-1">
            <Search className="w-5 h-5 text-gray-500" />
          </Link>
          <Link href="/notifications" className="p-1 relative">
            <Bell className="w-5 h-5 text-gray-500" />
            <span className="absolute -top-0.5 -right-0.5 w-2 h-2 bg-red-500 rounded-full" />
          </Link>
        </div>
      </div>
    </header>
  );
}
